import * as bkg_actn_types from './action_types'
import * as types from '../action_types'
import * as iid from '../../components/common/bookingElementId'
import {
  PostRequest,
  PostRequestV2,
  GetRequest,
  PostRequestCached,
  PostRequestCachedV2,
  GetRequestCached,
  GetRequestCached2,
  GetRequestCachedV3,
} from '../../components/common/api'
import { PICKUP_MODE, DROPOFF_MODE, urls, STA_TWO_WHEELER_C_ID, API_CACHE_DURATION } from '../../components/common/constants'
import { updateLoader, updateAlertError, updateModifyData } from '../common/common_action'
import { STA_COMPANY_ID } from '../../helper/companyIdhardcode'
import { paytypes } from '../../components/common/paymentsMode'

export const updateDetails = (sectName, key, value) => ({
  type: types.UPDATE_DETAILS,
  sectName,
  key,
  value,
})

export const updatePriceSectData = (key, data) => ({
  type: bkg_actn_types.PRICE_SECTION_DATA,
  key,
  data,
})

export const updateRateWisePriceSectData = (data,data2) => ({
  type: bkg_actn_types.RATE_WISE_PRICE_DATA,
  data,
  data2
})
export const removeRateWisePriceSectData = (data) => ({
  type: bkg_actn_types.RATE_WISE_PRICE_DATA_REMOVE,
  data,
})


export const updateConsignmentData = (param, key, data) => ({
  type: bkg_actn_types.CONSGMNT_SECTION_DATA,
  param,
  key,
  data,
})

export const updateConsignmentRowData = (param, data) => ({
  type: bkg_actn_types.CONSIGNMENT_ROW,
  param,
  data,
})

export const updatePriceSectionRowData = (data) => ({
  type: bkg_actn_types.PRICE_SECTION_ROW,
  data,
})

export function addNewRow() {
  return {
    type: bkg_actn_types.ADD_NEW_CONSIGNMENT_ROW,
  }
}

export function RemoveRow(index) {
  return {
    type: bkg_actn_types.REMOVE_CONSIGNMENT_ROW,
    index,
  }
}

export function updateRFC(data) {
  return {
    type: bkg_actn_types.RFC,
    data,
  }
}

export function updateDocumentChargeList(data) {
  return {
    type: bkg_actn_types.DOCUMENT_CHARGE_LIST,
    data,
  }
}
export const bookCargo = (data) => {
  return {
    type: bkg_actn_types.BOOK_CARGO,
    data,
  }
}
export const bookingPrintData = (data) => {
  return {
    type: bkg_actn_types.CARGO_PRINT_DATA,
    data,
  }
}
export const bookingRePrintData = (data) => {
  return {
    type: bkg_actn_types.CARGO_REPRINT_DATA,
    data,
  }
}
export const nearestStatesData = (data)=>{
  return {
    type: bkg_actn_types.NEAREST_STATES,
    data
  }
}
export const nearestCities = (data)=>{
  return {
    type: bkg_actn_types.NEAREST_CITIES,
    data
  }
}
export const nearestBranches = (data)=>{
  return {
    type: bkg_actn_types.NEAREST_BRANCH,
    data
  }
}
export const selectedNearestBrnch = (data)=>{
  return {
    type: bkg_actn_types.SELECTED_NEAREST_BRANCH,
    data
  }
}
export const updateProfileData = (data,category) => ({ type: bkg_actn_types.CUSTOMER_PROFILE_DETAIL, data,category })
export const cargoGetRateForConsignment =
  (data, slctdRwData = {}, slctdRowIndex, wtCharge, bU, callFromAdmin) =>
    (dispatch) => {
      PostRequestCached(urls.cargoGetRateForConsignment, data)
        .then((res) => {
          if (res.status == 'Success') {
            const rate = res.Data || 0
            dispatch(callFromAdmin ? updateModifyData(slctdRowIndex, `Rate`, rate) : updateConsignmentData(slctdRowIndex, `rate`, rate))
            if (bU && [1, 2].includes(bU)) {
              dispatch(
                callFromAdmin
                  ? updateModifyData(slctdRowIndex, 'Freight', bU == 2 ? slctdRwData.Quantity * rate : wtCharge * rate)
                  : updateConsignmentData(slctdRowIndex, 'freight', bU == 2 ? slctdRwData.unit * rate : wtCharge * rate)
              )
            }
          } else {
            // alert('something went wrong')
          }
        })
        .catch((err) => {
          dispatch(updateLoader(false))
          //   alert('something went wrong')
        })
    }

export const getAdditionalCharges = (data, companySettings) => (dispatch) => {
  const { intTotalQty } = data
  PostRequestCachedV2(urls.getAdditionalCharges, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        let tableData = res.Data.Table[0]
        let insurance = 0.0
        let hamaliCharge = 0.0
        if (companySettings?.IsInsurance) {
          if (tableData.InsuranceCharges > 0) {
            if (tableData.InsuranceAdditionalUnitAmt > 0) {
              let qty = intTotalQty - 1
              insurance = tableData.InsuranceCharges + qty * tableData.InsuranceAdditionalUnitAmt
            } else {
              insurance = tableData.InsuranceCharges
            }
          }
        }
        if (companySettings?.IsHamali) {
          hamaliCharge = tableData.HamaliCharges
        }
        // dispatch(updatePriceSectData('hamali', hamaliCharge))
        dispatch(updatePriceSectData('valuation', insurance))
      } else {
        // console.log(res)
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      // console.log(err)
    })
}
export const getDocumentChargesList = (loginData) => (dispatch) => {
  PostRequest(urls.getDocumentCharges, {
    intCompanyID: loginData.intCompanyID,
  })
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateDocumentChargeList(res.Data?.Table))
      } else {
        // console.log(res);
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      // console.log(err);
    })
}
export const getDocumentCharges = (companySettings, documentChargesList, PaymentTypeID, BillingUnit,unit) => (dispatch) => {
  if (companySettings?.IsDocument) {
    let isLRAssigned = false
    Object.keys(documentChargesList).map((keys) => {
      let dc = documentChargesList[keys]
      if (dc.BillingUnit == BillingUnit && dc.PayTypeID == PaymentTypeID && dc.ChargeTypeID == 1) {
        if(dc.ChargeTypeID == 1){
          dispatch(updatePriceSectData('doc_fee', dc.DocumentCharge))
        }else if(dc.ChargeTypeID=2){
          dispatch(updatePriceSectData('doc_fee', (dc.DocumentCharge*unit)))
        }else{
          dispatch(updatePriceSectData('doc_fee',0))
        }
        // if(BillingUnit==2){
        // dispatch(updatePriceSectData('doc_fee', (dc.DocumentCharge*unit)))
        // }else{
        //   dispatch(updatePriceSectData('doc_fee', dc.DocumentCharge))
        // }
        isLRAssigned = true
      } else if (dc.BillingUnit == BillingUnit && dc.PayTypeID == PaymentTypeID && dc.ChargeTypeID == 2 && !isLRAssigned) {
        dispatch(updatePriceSectData('doc_fee', (dc.DocumentCharge * unit)))
      }
    })
  }
}
export const pickupAndDropoffchargeList = (data, totalWeigtcharge) => (dispatch) => {
  const { ChargeTypeID, mode, unit } = data
  PostRequestCached(urls.pickupAndDropoffchargeList, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        Object.keys(res.Data.Table).map((key) => {
          let item = res.Data.Table[key]
          if(mode===PICKUP_MODE){
            // if(item.ChargeTypeID == res.Data?.Table1?.[0]?.CargoPkChgTypeID && item.RangeMin <= totalWeigtcharge && totalWeigtcharge <= item.RangeMax && item.IsActive==1){
            //   // console.log(totalWeigtcharge,res.Data?.Table1?.[0]?.CargoPkChgTypeID,item.ChargeTypeID,item )
            //   if(item.IsActive==1){
            //     if(res.Data?.Table1?.[0]?.CargoPkChgTypeID==1){
            //       dispatch(updatePriceSectData('pickup_fee', (item.Charge * totalWeigtcharge)))
            //     }else if(res.Data?.Table1?.[0]?.CargoPkChgTypeID==2){
            //       dispatch(updatePriceSectData('pickup_fee', (item.Charge * unit)))
            //     }else{
            //       dispatch(updatePriceSectData('pickup_fee', (item.Charge )))
            //     }
            //   }else{
            //     dispatch(updatePriceSectData('pickup_fee', 0))
            //   }
            // }
            if (res.Data?.Table1?.[0]?.CargoPkChgTypeID == 1) {
              if (item.ChargeTypeID == res.Data?.Table1?.[0]?.CargoPkChgTypeID && item.RangeMin <= totalWeigtcharge && totalWeigtcharge <= item.RangeMax) {
                if (item.IsActive == 1) {
                  dispatch(updatePriceSectData('pickup_fee', (item.Charge * totalWeigtcharge)))
                }
                else {
                  dispatch(updatePriceSectData('pickup_fee', (item.Charge)))
                }
              }
            } else if (res.Data?.Table1?.[0]?.CargoPkChgTypeID == 2) {
              if (item.ChargeTypeID == res.Data?.Table1?.[0]?.CargoPkChgTypeID && item.RangeMin <= unit && unit <= item.RangeMax) {
                if (item.IsActive == 1) {
                  dispatch(updatePriceSectData('pickup_fee', (item.Charge * unit)))
                }
                else {
                  dispatch(updatePriceSectData('pickup_fee', (item.Charge)))
                }
              }
            }
          }else if (mode == DROPOFF_MODE){
            // console.log("hello",item.RangeMin <= totalWeigtcharge && totalWeigtcharge <= item.RangeMax,totalWeigtcharge,item.ChargeTypeID ,res.Data?.Table1?.[0]?.CargoDrpOffChgTypeID)
            // if(item.ChargeTypeID == res.Data?.Table1?.[0]?.CargoDrpOffChgTypeID && item.RangeMin <= totalWeigtcharge && totalWeigtcharge <= item.RangeMax ){
            //   if(item.IsActive==1){
            //     if(res.Data?.Table1?.[0]?.CargoDrpOffChgTypeID==1){
            //       dispatch(updatePriceSectData('dropoff_fee', (item.Charge * totalWeigtcharge)))
            //     }else if(res.Data?.Table1?.[0]?.CargoDrpOffChgTypeID==2){
            //       dispatch(updatePriceSectData('dropoff_fee', (item.Charge * unit)))
            //     }else{
            //       dispatch(updatePriceSectData('dropoff_fee', (item.Charge )))
            //     }
            //   }else{
            //     dispatch(updatePriceSectData('dropoff_fee', 0))
            //   }
            // }
            if (res.Data?.Table1?.[0]?.CargoDrpOffChgTypeID == 1) {
              if (item.ChargeTypeID == res.Data?.Table1?.[0]?.CargoDrpOffChgTypeID && item.RangeMin <= totalWeigtcharge && totalWeigtcharge <= item.RangeMax) {
                if (item.IsActive == 1) {
                  dispatch(updatePriceSectData('dropoff_fee', (item.Charge * totalWeigtcharge)))
                }
                else {
                  dispatch(updatePriceSectData('dropoff_fee', (item.Charge)))
                }
              }
            } else if (res.Data?.Table1?.[0]?.CargoDrpOffChgTypeID == 2) {
              if (item.ChargeTypeID == res.Data?.Table1?.[0]?.CargoDrpOffChgTypeID && item.RangeMin <= unit && unit <= item.RangeMax) {
                if (item.IsActive == 1) {
                  dispatch(updatePriceSectData('dropoff_fee', (item.Charge * unit)))
                }
                else {
                  dispatch(updatePriceSectData('dropoff_fee', (item.Charge)))
                }
              }
            }
          }
        })
      } else {
        // console.log(res)
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      // console.log(err)
    })
}
export const bookingSave = (bookingData,onClose=null) => (dispatch) => {
  if (!bookingData.PaymentType) {
    dispatch(updateAlertError({ show: true, msg: 'Please select payment type', nextId: iid.comment }))
    return
  }
  if (!bookingData.DestinationBranchID) {
    dispatch(updateAlertError({ show: true, msg: 'Please select Destination Branch', nextId: iid.comment }))
    return
  }
  if (bookingData.PaymentType === paytypes.FOC && +bookingData.NetAmount>0) {
    dispatch(updateAlertError({ show: true, msg: 'Amount should be 0 for FOC', nextId: iid.comment }))
    return
  }
  PostRequest(urls.bookingSave, bookingData)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(bookCargo(res))
      } else {
        const msg = res.ErrMessage.split(':').pop()
        dispatch(updateAlertError({ show: true, msg: msg, nextId: iid.comment, close: onClose }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      // console.log(err)
    })
}
export const printCargoBooking = (loginData, props) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequestV2(urls.printCargoBooking, {
    intBookingID: props.BookingID,
    intBranchID: loginData.intBranchID,
    intUserID: loginData.intUserID,
    strLRNO: props.strLRNO || '',
    intmode: 0,
  })
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success' && res.Data && res.Data.Table) {
        dispatch(bookingPrintData(res.Data.Table[0]))
      } else {
        const msg = res.ErrMessage.split(':').pop()
        dispatch(updateAlertError({ show: true, msg: msg }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
export const rePrintCargoBooking = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequestV2(urls.printCargoBooking, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success' && res.Data && res.Data.Table) {
        dispatch(bookingRePrintData(res.Data.Table[0]))
      } else {
        const msg = res.ErrMessage.split(':').pop()
        dispatch(updateAlertError({ show: true, msg: msg, close: () => window.location.reload(false) }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}


export const getNearestStates = () => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getNearStateList, {
    StateID: 0,
  })
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(nearestStatesData(res.Data?.Table))
      } else {
        dispatch(nearestStatesData([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
export const getNearestCities = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getNearCityList, {
    CompanyID:  data?.CompanyID,
    StateID: data?.StateID,
  })
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(nearestCities(res.Data?.Table))
      } else {
        dispatch(nearestCities([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

export const getNearestBranches = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getNearBranchList, {
    CompanyID:data.CompanyID,
    StateID: data.StateID,
    CityIDs:data.CityIDs
  })
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(nearestBranches(res.Data?.Table))
      } else {
        dispatch(nearestBranches([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

//get own perent company
export const getBranchOwnParentCompany = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequestCachedV3(urls.getOwnParentCompany, obj,true,API_CACHE_DURATION)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const getBranchRecharge = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.branchAndPartyRecharge, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const getDynamicQRDetails = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequest(urls.getDQRDetails, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const getDQRDetailsInsertUpdate = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    // dispatch(updateLoader(true))
    PostRequest(urls.getQRDetailsInsert, obj)
      .then((res) => {
        // dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        // dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const BranchRechargeConfirm = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    // dispatch(updateLoader(true))
    PostRequest(urls.getBranchRechargeConfm, obj)
      .then((res) => {
        // dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        // dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const BranchRechargeReject = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    // dispatch(updateLoader(true))
    PostRequest(urls.getBranchRecahrgeRjct, obj)
      .then((res) => {
        // dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        // dispatch(updateLoader(false))
        reject(error)
      })
  })
}


